<template>
  <div class="register">
    <div class="title">用户注册</div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="register_form"
    >
      <el-form-item label="用户类型" prop="type">
        <el-radio-group v-model="ruleForm.type">
          <el-radio label="6">个人用户</el-radio>
          <el-radio label="7">团队用户</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="姓名" prop="name">
        <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="单位名称" prop="unit" v-if="ruleForm.type == 7">
        <el-input
          v-model="ruleForm.unit"
          placeholder="请输入单位名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="证件类型" prop="idType">
        <el-radio-group v-model="ruleForm.idType">
          <el-radio label="0">居民身份证</el-radio>
          <el-radio label="1">护照</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="证件号码" prop="idNumber">
        <el-input
          v-model="ruleForm.idNumber"
          placeholder="请输入证件号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="电子邮箱" prop="email">
        <el-input
          v-model="ruleForm.email"
          placeholder="请输入电子邮箱"
        ></el-input>
      </el-form-item>
      <el-form-item label="验证码" class="verifyCode" prop="captcha">
        <el-input
          v-model="ruleForm.captcha"
          placeholder="请输入验证码"
        ></el-input>
        <el-button
          type="primary"
          style="margin-left: 10px"
          icon="el-icon-message"
          @click="sendCode"
          >验证码</el-button
        >
      </el-form-item>

      <el-form-item label="手机号" prop="phone">
        <el-input
          v-model="ruleForm.phone"
          placeholder="请输入手机号"
          maxlength="11"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          v-model="ruleForm.password"
          type="password"
          placeholder="请输入密码"
        ></el-input>
        <div class="tips">注:密码不少于8位，且包含大小写字母数字</div>
      </el-form-item>
      <el-form-item label="确认密码" prop="repassword">
        <el-input
          v-model="ruleForm.repassword"
          type="password"
          placeholder="请再次输入密码"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          class="submitBtn"
          @click="register('ruleForm')"
          >立即注册</el-button
        >
        <el-button @click="resetForm('ruleForm')">重置</el-button>
        <el-button @click="goback" icon="el-icon-refresh-left"
          >返回登录</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  sendMessaheCode,
  register,
  getVeficationCode,
  sendEmail,
} from "@/libs/api";
import verifyCode from "@/components/util/identify.vue";

export default {
  data() {
    var unitCheck = (rule, value, callback) => {
      if (this.ruleForm.type == "7" && value == "") {
        callback(new Error("单位名称不能为空"));
      } else {
        callback();
      }
    };
    var repasswordCheck = (rule, value, callback) => {
      if (value != this.ruleForm.repassword || value == "") {
        callback(new Error("两次填入的密码需要保持一致"));
      } else {
        callback();
      }
    };
    var emailCheck = (rule, value, callback) => {
      var rege = new RegExp(
        /^[\w.-]+@[\w-]+(\.[\w-]+)+$/
      );
      if (!rege.test(value) || value == "") {
        callback(new Error("请输入正确的邮箱格式"));
      } else {
        callback();
      }
    };
    return {
      disabled: false,
      timer: {
        time: 60,
        message: "获取验证码",
        value: "",
      },
      ruleForm: {
        type: "6",
        name: "",
        idType: "0",
        idNumber: "",
        unit: "",
        password: "",
        repassword: "",
        phone: "",
        captcha: "",
        email: "",
      },
      rules: {
        email: [{ required: true, validator: emailCheck, trigger: "blur" }],
        type: [
          { required: true, message: "请选择用户类型", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        idType: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        idNumber: [
          { required: true, message: "请输入证件号", trigger: "blur" },
        ],
        unit: [{ required: true, validator: unitCheck, trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { size: 11, message: "请输入11位的手机号", trigger: "blur" },
        ],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 5, message: "长度不能低于5位字符", trigger: "blur" },
        ],
        repassword: [
          { required: true, validator: repasswordCheck, trigger: "blur" },
        ],
      },
      captcha: "",
      captchaId: "",
    };
  },
  components: {
    verifyCode,
  },

  watch: {
    "ruleForm.type"(after, before) {
      this.ruleForm.unit = before == 5 ? "" : this.ruleForm.unit;
    },
  },
  methods: {
    getVeficationCode: function () {
      getVeficationCode().then((res) => {
        if (res.status) {
          this.captcha = res.content.captcha;
          this.captchaId = res.content.captchaId;
        }
      });
    },

    //发送邮箱验证码
    sendCode() {
      if (this.ruleForm.email == "") {
        this.$alert("请输入您的邮箱地址", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            loading.close();
          },
        });
        return;
      }
      let reg = /^[\w.-]+@[\w-]+(\.[\w-]+)+$/;
      
      if (!reg.test(this.ruleForm.email)) {
        this.$alert("请输入正确的邮箱地址", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            loading.close();
          },
        });
        return;
      }
      sendEmail({ type: 1, email: this.ruleForm.email }).then((res) => {
        if (res.status) {
          this.$message({
            message: "验证码已经发送到邮箱，请注意查收",
            type: "success",
          });
          this.captchaId = res.data;
        }
      });
    },
    sendMessaheCode: function () {
      if (this.ruleForm.phone.length == 11) {
        sendMessaheCode(this.ruleForm.phone).then((res) => {
          if (res.status) {
            this.$message({
              message: "短信发送成功",
              type: "success",
            });
            //禁止点击按钮
            this.disabled = true;
            //定时器定时读秒
            this.timer.value = setInterval(() => {
              this.timer.time--;
              this.timer.message = "还剩" + this.timer.time + "秒";
              if (this.timer.time == 0) {
                //关闭定时器，启用按钮
                window.clearInterval(this.timer.value);
                this.timer.message = "获取验证码";
                this.disabled = false;
                this.timer.time = 60;
              }
            }, 1000);
          }
        });
      } else {
        this.$alert("请输入正确的手机号", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      }
    },
    register: function () {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!/^1[3456789]\d{9}$/.test(this.ruleForm.phone.trim()))
            return this.$alert("请输入正确的手机号码~");
          const loading = this.$loading({
            lock: true,
            text: "注册中, 请稍后",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          register(this.ruleForm, this.ruleForm.captcha, this.captchaId).then(
            (res) => {
              if (res.status) {
                loading.close();
                this.$alert("注册成功!", "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.$router.push({ name: "login" });
                  },
                });
              } else {
                this.$alert("注册失败。" + res.message, "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    loading.close();
                  },
                });
              }
            }
          );
        }
      });
    },
    resetForm: function () {
      this.$refs["ruleForm"].resetFields();
    },
    goback: function () {
      this.$router.go(-1);
    },
  },
  created() {
    // this.getVeficationCode();
  },
};
</script>
<style scoped lang='less'>
.register {
  margin: 0 auto;
  margin-top: 6vh;
  width: 30%;
  background-color: white;
  border-radius: 5px;
  box-sizing: border-box;
  background-image: url("~@/assets/images/registerbg.jpg");
  background-repeat: no-repeat;
  background-position: bottom;
  background-color: #f1eee7;
  .title {
    font-size: 20px;
    height: 6vh;
    display: flex;
    align-items: center;
    padding-left: 2%;
    border-bottom: 1px solid #ccc;
    width: 95%;
    margin: 0 auto;
    box-sizing: border-box;
  }
  .register_form {
    width: 93%;
    padding-top: 3vh;
    padding-bottom: 1.5vh;
    .verifyCode {
      .el-input {
        width: 73%;
      }
      .el-form-item__content {
        display: flex;
        font-size: 20px;
      }
    }
    .el-select {
      width: 100%;
    }
    .submitBtn {
      background-color: #ae0c2a;
      border: none;
    }
  }
  .tips {
    font-size: 12px;
    height: 20px;
  }
}
</style>
<style lang='less'>
.verifyCode {
  color: red;
  .el-form-item__content {
    display: flex;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/single/register.vue